export const setFormValidationErrors = (errors) => (dispatch) => dispatch({
    type: 'FORM_VALIDATION_ERRORS_SET',
    errors,
});

export const setFormValidationDisplay = (showErrors) => (dispatch) => dispatch({
    type: 'FORM_VALIDATION_DISPLAY_SET',
    showErrors,
});
